import { useAppSelector } from 'hooks';
import React from 'react';
import styles from './styles.module.sass';

export const AccountFacilities = () => {
  const { accountFacilities } = useAppSelector(({ facility }) => facility);

  if (!accountFacilities || !accountFacilities.length) {
    return <h2>Your have no facilities</h2>;
  }

  return (
    <div className={styles.container}>
      <h2>Your facilities:</h2>
      <div className={styles.facilities_container}>
        {accountFacilities.map((facility) => (
          <h5 key={facility.id}>{facility.name}</h5>
        ))}
      </div>
    </div>
  );
};
